// Plugin Leads - Export principale
// Questo file espone tutti i componenti e servizi del plugin
// e auto-registra la KPI del plugin nel registry dashboard.

import { UserPlus } from "lucide-react"
import { registerKpi } from "../../lib/kpi-registry"
import { getLeads } from "./services/leads"

// Componenti
export { LeadsContent } from "./components/LeadsContent"
export { LeadDetailPanel } from "./components/LeadDetailPanel"

// Pagine
export { default as LeadsPageWrapper } from "./pages/LeadsPageWrapper"

// Servizi
export * from "./services/leads"

registerKpi({
  id: "leads",
  label: "Leads",
  icon: UserPlus,
  order: 10,
  isPlugin: true,
  moduleName: "leads",
  linkTo: "/leads",
  colorAccent: "#ec4899",
  fetchData: async () => {
    try {
      const response: any = await getLeads({ status: "new" })
      const data = response?.data
      let value = 0
      if (typeof data?.count === "number") {
        value = data.count
      } else {
        const arr = Array.isArray(data?.results) ? data.results : Array.isArray(data) ? data : []
        value = arr.filter((l: any) => l?.status === "new").length
      }
      return {
        value,
        subtitle: value > 0 ? "nuovi" : undefined,
      }
    } catch {
      return { value: 0 }
    }
  },
})
